module.exports = __webpack_public_path__ + "img/logo.9176e7c8.jpg";